export const NO_MOVIE = "No movie available";
export const NO_SHOWS = "No shows available";
export const NO_ADVERTISEMENT = "No offers available";
export const SHOW_BOOKING_CLOSED =
  "Online booking is closed for this show. You can still view seat availability — please visit the hall counter to buy tickets.";
export const PAYMENT_ERROR =
  "We're sorry, but your payment could not be processed at this time.\nPlease check your payment details and try again, or contact our support team for assistance";
